import React, { Component } from 'react';
import { ComboBox, DropdownSkeleton } from 'carbon-components-react';
import PropTypes from 'prop-types';
import AuditRepository from '../../../helpers/api/AuditRepository';

export default class AuditTargetDropDown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      items: [],
    };
    this.onChange = this.onChange.bind(this);
    this.repository = new AuditRepository();
  }

  async componentDidMount() {
    this.setState({ loading: true });
    const items = await this.getItems();
    this.setState({ items, loading: false });
  }

  onChange = (selectedItem) => {
    const item = selectedItem ? selectedItem.selectedItem : null;
    this.props.onChange(item);
  };

  getItems = async () => {
    let items = [];

    try {
      items = await this.repository.getTargets();
    } catch (error) {
      console.error(error);
      this.props.onError(error);
    }
    return items;
  };

  render() {
    return this.state.loading ? (
      <DropdownSkeleton />
    ) : (
      <ComboBox
        direction={this.props.openUp ? 'top' : 'bottom'}
        id="comboBoxTarget"
        invalid={this.props.invalid}
        invalidText={this.props.invalidText}
        disabled={this.state.items < 1 || this.props.disabled}
        placeholder="Choose a target"
        items={this.state.items}
        onChange={this.onChange}
        itemToString={(item) => (item ? item && item.name : '')}
        selectedItem={this.props.initialSelectedItem}
      />
    );
  }
}

AuditTargetDropDown.propTypes = {
  invalid: PropTypes.bool,
  invalidText: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  initialSelectedItem: PropTypes.object,
  disabled: PropTypes.bool,
};
AuditTargetDropDown.defaultProps = {
  invalid: false,
  invalidText: '',
  initialSelectedItem: null,
  disabled: true,
};
